// 학교 타입별 학년 변환 유틸리티

/**
 * UI에서 입력받은 상대 학년을 백엔드용 절대 학년으로 변환
 * @param {number} schoolType - 학교 타입 (1: 초등, 2: 중등, 3: 고등)
 * @param {number} relativeGrade - 상대 학년 (1~6 또는 1~3)
 * @returns {number} 절대 학년 (1~12)
 */
export const convertToAbsoluteGrade = (schoolType, relativeGrade) => {
  const type = parseInt(schoolType);
  const grade = parseInt(relativeGrade);
  
  switch (type) {
    case 1: // 초등학교
      return grade; // 1~6학년 그대로
    case 2: // 중학교
      return grade + 6; // 1~3학년 → 7~9학년
    case 3: // 고등학교
      return grade + 9; // 1~3학년 → 10~12학년
    default:
      return grade;
  }
};

/**
 * 백엔드에서 받은 절대 학년을 UI용 상대 학년으로 변환
 * @param {number} absoluteGrade - 절대 학년 (1~12)
 * @returns {object} {schoolType, relativeGrade}
 */
export const convertToRelativeGrade = (absoluteGrade) => {
  const grade = parseInt(absoluteGrade);
  
  if (grade >= 1 && grade <= 6) {
    return { schoolType: 1, relativeGrade: grade }; // 초등학교
  } else if (grade >= 7 && grade <= 9) {
    return { schoolType: 2, relativeGrade: grade - 6 }; // 중학교
  } else if (grade >= 10 && grade <= 12) {
    return { schoolType: 3, relativeGrade: grade - 9 }; // 고등학교
  } else {
    return { schoolType: null, relativeGrade: grade };
  }
};

/**
 * 학교 타입에 따른 학년 옵션 반환
 * @param {number} schoolType - 학교 타입
 * @returns {Array} 학년 옵션 배열
 */
export const getGradeOptions = (schoolType) => {
  const type = parseInt(schoolType);
  
  switch (type) {
    case 1: // 초등학교
      return [
        { value: '1', label: '1학년' },
        { value: '2', label: '2학년' },
        { value: '3', label: '3학년' },
        { value: '4', label: '4학년' },
        { value: '5', label: '5학년' },
        { value: '6', label: '6학년' }
      ];
    case 2: // 중학교
    case 3: // 고등학교
      return [
        { value: '1', label: '1학년' },
        { value: '2', label: '2학년' },
        { value: '3', label: '3학년' }
      ];
    default:
      return [
        { value: '1', label: '1학년' },
        { value: '2', label: '2학년' },
        { value: '3', label: '3학년' }
      ];
  }
};

/**
 * 학교 타입에서 학교명 추출 (고등학교만 처리)
 * @param {string} schoolName - 학교명
 * @returns {number} 학교 타입 (3: 고등학교)
 */
export const getSchoolTypeFromName = (schoolName) => {
  if (schoolName && schoolName.includes('고')) {
    return 3; // 고등학교
  }
  // 추후 중학교, 초등학교 판별 로직 추가 가능
  return 3; // 기본값 고등학교
}; 